import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles/index";

const styles = () => ({
  bannerContainer: {
    width: 400,
    //height: 100,
    border: "1px solid #0094E0",
    boxShadow: "0 3px 8px 0 rgba(0,0,0,0.20)",
    borderRadius: 8,
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
  },
  taglineContainer: {
    width: 34,
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    backgroundColor: "#0094E0",
    writingMode: "vertical-rl",
    textOrientation: "mixed",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 17,
    whiteSpace: "nowrap",
  },

  graphic: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    objectFit: "cover",
    width: 92,
    maxWidth: 92,
    minWidth: 92,
    height: 128,
    overflow: "hidden",
    position: "relative",
    //marginLeft: 10,
    //marginRight: 10,
    //border: "1px solid #D8D8D8",
    paddingRight: 9,
  },

  innerGraphicOverlay: {
    opacity: 0.2,
    backgroundColor: "#ddd",
    position: "absolute",
    height: "100%",
    width: "100%",
    top: 0,
    left: 0,
  },
  innerGraphic: {
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  messagingContainer: {},
  title: {
    fontSize: 20,
    fontWeight: 800,
    color: "#333",
    letterSpacing: "1px",
    lineHeight: 1.1,
    paddingRight: 34,
  },

  dateTimeLine: {
    paddingTop: 5,
    fontSize: 14,
    color: "#777",
  },
});

class NewsBanner extends Component {
  render() {
    const {
      title,
      dateTimeLine,
      bannerColor,
      bannerTagline,
      resourceUrl,
      classes,
    } = this.props;

    let taglineSize = 18;
    if (bannerTagline) {
      if (bannerTagline.length > 6 && bannerTagline.length < 10) {
        taglineSize = 15;
      } else if (bannerTagline.length > 10) {
        taglineSize = 12;
      }
    }

    return (
      <div
        className={classes.bannerContainer}
        style={{ borderColor: bannerColor }}
      >
        <div className={classes.graphic}>
          <div
            style={{ backgroundImage: `url(${resourceUrl})` }}
            className={classes.innerGraphic}
          />

          {/* 
          <div className={classes.innerGraphicOverlay} />
		  */}
        </div>
        <div className={classes.messagingContainer}>
          <div className={classes.title}>{title}</div>
          <div className={classes.dateTimeLine}>{dateTimeLine}</div>
        </div>
        <div
          className={classes.taglineContainer}
          style={{ backgroundColor: bannerColor }}
        >
          <div style={{ fontSize: taglineSize }}>{bannerTagline}</div>
        </div>
      </div>
    );
  }
}

NewsBanner.propTypes = {
  title: PropTypes.string,
  dateTimeLine: PropTypes.string,
  bannerColor: PropTypes.string,
  bannerTagline: PropTypes.string,
  resourceId: PropTypes.number,
  resourceUrl: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles)])(NewsBanner);
